<mat-toolbar class="footer-toolbar">
  <div class="footer-content">
    <div class="footer-section">
      <div class="footer-item">
        <mat-icon>update</mat-icon>
        <span>Last Update: 15 May 2026</span>
      </div>
      <div class="footer-item">
        <mat-icon>copyright</mat-icon>
        <span>© 2001 - 2026 Chevron Corporation</span>
      </div>
    </div>

   

    <div class="footer-section footer-center">
      <div class="footer-item">
        <mat-icon>contact_mail</mat-icon>
        <span>Content Contact: <a href="mailto:rohitmane@chevron.com">Mane, Rohit</a></span>
      </div>
      <div class="footer-item">
        <mat-icon>support</mat-icon>
        <span>Technical Contact: <a href="mailto:SDP-LTI-AMSTeam-Pod2@chevron.com">SURFACE-APPLICATION SUPPORT-POD2</a></span>
      </div>
      <div class="footer-item">
        <mat-icon>help</mat-icon>
        <span>Need help for Surface applications? <a href="https://go.chevron.com/appsupport" target="_blank">Submit a SNOW ticket here</a></span>
      </div>
    </div>

  

    <div class="footer-section">
      <div class="footer-item">
        <mat-icon>security</mat-icon>
        <span>Company Confidential</span>
      </div>
      <div class="footer-item">
        <mat-icon>business</mat-icon>
        <span>Opco: <a href="http://midstream.chevron.com/">Midstream Strategy & Policy</a></span>
      </div>
      <div class="footer-item">
        <mat-icon>person</mat-icon>
        <span>Your User ID: {{user.userName}}</span>
      </div>
    </div>
  </div>
</mat-toolbar>
